export const MIN_BANNER_HEIGHT = 105;
export const BANNER_NAME = 'CookiesConsentBanner';
